export const overrides = {
    MuiTableCell: {
        head: {
            fontWeight: 800
        }
    }
};
